import { Button, Container, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axiosApi from "../../axios/axios-api";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { LogoPetroprix } from "../ui/LogoPetroprix";
import { changeKmFlota } from "../../store/auth";
import { useState } from "react";
import { MiniLoader } from "../ui/MiniLoader";
import { ValidateToken } from "../../helpers/validateToken";

const URL_PUT_DESBLOQUEAR_VEHICULO = "flotas/vehiculos/desbloquear/";

export function ModalInfoBloqueado(props) {
  const { show, onHide, vehiculo } = props;
  const { token, flotaActiva } = useSelector((state) => state.auth);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const unlockVehicle = async () => {
    setLoading(true);
    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.put(
          `${URL_PUT_DESBLOQUEAR_VEHICULO}${vehiculo.id_vehiculo_flota}`,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response?.data?.code === 200) {
          toast(response?.data?.message, {
            icon: <LogoPetroprix />,
          });
          setLoading(false);
          onHide(true);
        } else {
          onHide(false);
          setLoading(false);
          toast(response?.data?.message, {
            icon: <LogoPetroprix />,
          });
        }
      } else {
        dispatch(startLogout("expired"));
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      toast(t("flotas.modal.bloqueado.error"), {
        icon: <LogoPetroprix />,
      });
      setLoading(false);
    }
  };

  return (
    <Modal
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={() => onHide({ show: false })}
    >
      <Container className="py-5">
        <Modal.Body>
          <h3 className="title-modal">{t("flotas.modal.bloqueado.h3")}</h3>
          <div className="d-grid gap-2  mt-2">
            {flotaActiva?.permisos == 1 ? (
              <>
                <p style={{ textAlign: "center", fontSize: "1.2rem" }}>
                  {t("flotas.modal.bloqueado.desbloquear.p")}
                  <strong>{vehiculo?.matricula}</strong>
                  {t("flotas.modal.bloqueado.desbloquear.p-2")}
                </p>
                <p style={{ textAlign: "center" }} className="-mt-3">
                  {t("flotas.modal.bloqueado.desbloquear.p-3")}
                </p>
              </>
            ) : (
              <p>{t("flotas.modal.bloqueado.p")}</p>
            )}
          </div>
          <div className="d-grid gap-2  mt-5">
            <Button
              variant="primary"
              size="lg"
              onClick={unlockVehicle}
              disabled={loading}
            >
              {loading ? (
                <MiniLoader />
              ) : (
                t("flotas.modal.bloqueado.btn-desbloquear")
              )}
            </Button>
            <Button
              variant="outline-primary"
              size="lg"
              onClick={() => {
                onHide(false, false);
              }}
              disabled={loading}
            >
              {t("flotas.modal.bloqueado.btn-cerrar")}
            </Button>
          </div>
        </Modal.Body>
      </Container>
    </Modal>
  );
}
